import React from "react";
import { useNavigate } from "react-router-dom";
import { Drawer } from "antd";
import {
  CaretDownOutlined,
  MailOutlined,
  BankOutlined,
  NumberOutlined,
  EnvironmentOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import chatImg from "Images/chat.svg";
import config, {
  DUMMY_EMAIL_DOMAIN,
  ORDER_CHANNEL,
  USER_TYPE,
} from "Utils/constant";
import { AppContext } from "Store";
import { getSwithcSTAddress } from "Utils/addressUtils";
import UserIcon from "Components/icons/userIcon";

const MHeader: React.FC<any> = (props) => {
  const navigate = useNavigate();
  const { title } = props;
  const { loginState } = React.useContext(AppContext);
  const [customerOpen, setCustomerOpen] = React.useState(false);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const orderChannel = loginState?.proxyUser?.orderChannel;
  const userInfo = loginState?.user?.user;
  const currentShipTo = loginState?.user?.allShipToBillToAddresses?.[0]?.shipTo;
  const pageTitle = isEmployee
    ? orderChannel === ORDER_CHANNEL.ONLINE
      ? "组合购 - 预购单"
      : orderChannel === ORDER_CHANNEL.OFFLINE
      ? "组合购 - 上传凭证入单"
      : ""
    : title;
  const customerName =
    `${userInfo?.lastName || ""}${userInfo?.firstName || ""}` || "";
  const customerEmail =
    userInfo?.userName ||
    userInfo?.contactInfo?.primaryEmail ||
    "";
  const customerCompany = currentShipTo?.companyOrInstitution || "";
  const customerStNumber = currentShipTo?.accountNumber || "";
  const customerAddress = currentShipTo
    ? getSwithcSTAddress(currentShipTo)
    : "";
  const isDummyCustomer = userInfo?.userName?.includes(DUMMY_EMAIL_DOMAIN);

  const renderDrawerTitle = (label: string, onClose: () => void) => (
    <div className="mobileDrawerTitleBar">
      <span>{label}</span>
      <button
        type="button"
        className="mobileDrawerCloseBtn"
        onClick={onClose}
      >
        <CloseOutlined />
      </button>
    </div>
  );

  return (
    <div className="mobilePageHeader">
      <header className="App-header">
        <div className="App-head">
          <svg
            style={{
              fill: "currentColor",
              width: isEmployee ? "20px" : "1em",
              height: isEmployee ? "20px" : "1em",
              display: "inline-block",
              fontSize: "1.5rem",
              flexShrink: 0,
              userSelect: "none",
            }}
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
            onClick={() => {
              navigate(-1);
            }}
          >
            <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
          </svg>
          <span
            className={`headerTitle${isEmployee ? " headerTitleEmployee" : ""}`}
          >
            {pageTitle}
          </span>
        </div>
        <div className="App-headright">
          {isEmployee ? (
            <button
              type="button"
              className="mobileEmployeeTrigger customer"
              onClick={() => setCustomerOpen(true)}
            >
              <span style={{ position: "relative", left: "2px", display: 'flex', alignItems: 'center' }}>
                <UserIcon color="#333" width={19} height={19} />
              </span>
              <span className="mobileEmployeeTriggerLabel">客户:</span>
              <span className="mobileEmployeeTriggerValue">
                {isDummyCustomer ? customerStNumber : customerName || customerStNumber}
              </span>
              <CaretDownOutlined className="mobileEmployeeTriggerArrow" />
            </button>
          ) : (
            <div style={{ margin: "0px 8px" }}>
              <img
                style={{ verticalAlign: "middle" }}
                src={chatImg}
                alt="chat"
                data-analytics-location="chat:header:chat-icon"
                data-chat-support-type="overall"
                data-analytics-track-now="true"
                onClick={() => {
                  window.location.href = `${config.APPLICATION_ENDPOINT}/zhichi-consult`;
                }}
              />
            </div>
          )}
        </div>
      </header>
      <Drawer
        title={renderDrawerTitle("客户详细信息", () => setCustomerOpen(false))}
        placement="bottom"
        height="auto"
        open={customerOpen}
        onClose={() => setCustomerOpen(false)}
        className="mobileHeaderDrawer"
        closable={false}
      >
        <div className="mobileEmployeePanel">
          {!isDummyCustomer && (
            <>
              <div className="mobileEmployeeInfoItem">
                <span className="mobileEmployeeInfoIcon">
                  <UserIcon width={18} height={18} />
                </span>
                <div>
                  <div className="mobileEmployeeInfoLabel">客户姓名</div>
                  <div className="mobileEmployeeInfoValue">{customerName || "-"}</div>
                </div>
              </div>
              <div className="mobileEmployeeInfoItem">
                <MailOutlined className="mobileEmployeeInfoIcon" />
                <div>
                  <div className="mobileEmployeeInfoLabel">Login Account</div>
                  <div className="mobileEmployeeInfoValue">{customerEmail || "-"}</div>
                </div>
              </div>
            </>
          )}
          <div className="mobileEmployeeInfoItem">
            <BankOutlined className="mobileEmployeeInfoIcon" />
            <div>
              <div className="mobileEmployeeInfoLabel">公司名称</div>
              <div className="mobileEmployeeInfoValue">{customerCompany || "-"}</div>
            </div>
          </div>
          <div className="mobileEmployeeInfoItem">
            <NumberOutlined className="mobileEmployeeInfoIcon" />
            <div>
              <div className="mobileEmployeeInfoLabel">ST Number</div>
              <div className="mobileEmployeeInfoValue">{customerStNumber || "-"}</div>
            </div>
          </div>
          <div className="mobileEmployeeInfoItem">
            <EnvironmentOutlined className="mobileEmployeeInfoIcon" />
            <div>
              <div className="mobileEmployeeInfoLabel">收货地址</div>
              <div className="mobileEmployeeInfoValue">{customerAddress || "-"}</div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default MHeader;
